module.exports = __webpack_public_path__ + "static/media/filterRowsGeneral.b126fdf5.txt";